module.exports = __webpack_public_path__ + "img/symbol_17.1c9bf83e.png";